import STForumCategoryHeader from "../../assets/styles/organisms/forumCategoryHeader.module.scss";

type ForumCategoryHeaderProps = {
  id: number;
  color: string;
  title: string;
  description: string;
};

const ForumCategoryHeader = (props: ForumCategoryHeaderProps) => {
  const { color, title, description } = props ?? {};
  return (
    <div
      style={{ backgroundColor: color }}
      className={STForumCategoryHeader.categoryHeader}
    >
      <div className={STForumCategoryHeader.categoryInformation}>
        <span className={STForumCategoryHeader.categoryTitle}>{title}</span>
        <span className={STForumCategoryHeader.categoryDescription}>
          {description}
        </span>
      </div>
    </div>
  );
};

export default ForumCategoryHeader;
